import React from "react";
import { Link } from "react-router-dom";
import "./assets/css/Error.css"; // você pode criar um CSS separado ou colocar direto onde preferir

const Error = () => {
  return (
      <div className="error-page d-flex align-items-center justify-content-center vh-100 bg-light">
        <div className="text-center">
          <h1 className="display-1 fw-bold text-danger">404</h1>
          <h3 className="mb-3 text-dark">
            <i className="fa fa-warning text-warning me-2" />
            Opa! Página não encontrada.
          </h3>
          <p className="lead text-muted">
            A página que você está tentando acessar não existe ou foi movida.
          </p>
          <Link to="/admin" className="btn btn-primary mt-3">
            Voltar para o Início
          </Link>
        </div>
      </div>
  );
};

export default Error;
